import styles from './Finish.module.scss';
import icon from '../../resources/pics/success.png';
import cn from "classnames";
import {Link} from "../Link/Link";

export const Finish = ({show, animate}) => {
    return (
        <div className={cn(styles.finish, show ? styles.active : '', animate ? styles.show : '')}>
            <div className={styles.wrapper}>
                <div className={styles.pic}>
                    <img src={icon} alt="Сбербанк"/>
                </div>
                <div className={styles.text}>
                    <div className={cn('text-body', styles.title)}>Все представленные пары оказались неудачными, но у Сбера появился универсальный вариант — металлический счёт</div>
                    <div className={cn('text-small', styles.desc)}>И героям мультов 2x2, и нашим зрителям рекомендуем вкладываться не в слова и продукты питания, а в драгоценные металлы. Захламлять свою квартиру, кстати, не придётся, ведь Сбер позволяет держать всё добро в онлайне!</div>
                    <div className={cn('text-small', styles.desc)}>Золото, серебро и платина были в цене тысячу лет назад, но и теперь не собираются сдавать позиции, ведь в исторической перспективе их стоимость растет. Маленькие блестящие слитки не только выглядят гораздо круче, чем бумажные деньги, кошачьи лотки и пончики, но и могут позволить получить доход.</div>

                    <Link url="http://www.sberbank.ru/ru/person/investments/values/omsc?utm_source=2x2.ru&utm_medium=cpc&utm_campaign=oms_specialproject_person_sp_dec-2022" text="Узнать больше" target="_blank" rel="nofollow noreferrer" />
                </div>
            </div>
        </div>
    )
}